import { render } from "./ScreenQuestionMultipleOptionsBP.vue?vue&type=template&id=0a966884&scoped=true&ts=true"
import script from "./ScreenQuestionMultipleOptionsBP.vue?vue&type=script&lang=ts"
export * from "./ScreenQuestionMultipleOptionsBP.vue?vue&type=script&lang=ts"

import "./ScreenQuestionMultipleOptionsBP.vue?vue&type=style&index=0&id=0a966884&scoped=true&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a966884"]])

export default __exports__